import React from 'react';
import { Text } from 'react-konva';

interface TextLabelProps {
  x: number;
  y: number;
  text: string | number;
  color: string;
}

const TextLabel: React.FC<TextLabelProps> = ({ x, y, text, color }) => {
  const textStr = typeof text === 'string' ? text : text.toString();
  const needsMoreSpace = textStr.length > 2;

  // Adjust dimensions for longer text
  const width = needsMoreSpace ? 40 : 16;
  const height = needsMoreSpace ? 40 : 16;
  const fontSize = needsMoreSpace ? 9 : 11;

  return (
    <Text
      x={x - width / 2}
      y={y - height / 2}
      width={width}
      height={height}
      text={textStr}
      fontSize={fontSize}
      fontFamily="Arial"
      fill={color}
      align="center"
      verticalAlign="middle"
      wrap="char"
    />
  );
};

export default TextLabel;
